var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDpdLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 34,
    viewBox: "0 0 80 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3295_41006)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.089 27.9543C50.6275 28.3601 48.7243 28.5294 47.0925 28.5294C42.8428 28.5294 40.0547 26.3314 40.0547 22.3092C40.0547 18.4883 42.6726 16.0204 46.479 16.0204C47.3302 16.0204 48.2473 16.1211 48.7918 16.391V10.8481H52.089V27.9543ZM48.7918 19.2327C48.281 18.9947 47.5679 18.8605 46.752 18.8605C44.746 18.8605 43.421 20.0777 43.421 22.207C43.421 24.4721 44.8488 25.758 47.1953 25.758C47.6017 25.758 48.2473 25.758 48.7918 25.6222V19.2327ZM79.1836 27.9543C77.7221 28.3601 75.8173 28.5294 74.1518 28.5294C69.9374 28.5294 67.1155 26.3314 67.1155 22.3092C67.1155 18.4883 69.7334 16.0204 73.5398 16.0204C74.4232 16.0204 75.3065 16.1211 75.8526 16.391V10.8481H79.1836V27.9543ZM75.8526 19.2327C75.3419 18.9947 74.6625 18.8605 73.845 18.8605C71.8053 18.8605 70.4803 20.0777 70.4803 22.207C70.4803 24.4721 71.9418 25.758 74.2867 25.758C74.6962 25.758 75.3081 25.758 75.8526 25.6222V19.2327ZM57.2911 19.2327C57.834 18.9947 58.6161 18.9276 59.2618 18.9276C61.3015 18.9276 62.6956 20.0777 62.6956 22.1383C62.6956 24.5743 61.1313 25.6893 59.0578 25.7228V28.5294H59.2281C63.5115 28.5294 66.0619 26.1972 66.0619 22.0377C66.0619 18.2519 63.3412 16.0204 59.3309 16.0204C57.2911 16.0204 55.2835 16.4932 53.9585 17.0347V33.0931H57.2911V19.2327Z",
    fill: "#3F3F42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.699 8.64875H28.7344H28.699ZM27.8848 8.20947L28.4276 8.81807L28.7328 8.64875L27.8848 8.20947Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0703 7.77002L28.1239 8.98721L28.4981 8.78435L28.0902 8.31153L27.0703 7.77002Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2188 7.33057L27.8168 9.15636L28.191 8.95349L27.2739 7.87048L26.2188 7.33057Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4023 6.8916L27.5111 9.32439L27.8853 9.12153L26.4238 7.42991L25.4023 6.8916ZM29.4497 11.1853L29.2104 11.3195L29.4481 11.5911V11.1853H29.4497Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5879 6.45068L27.2058 9.49367L27.5784 9.2908L25.6061 6.99219L24.5879 6.45068ZM29.313 11.2524L28.9388 11.4888L29.4479 12.0974V11.4552L29.313 11.2524Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7363 6.01123L26.8987 9.66281L27.3066 9.45994L24.7899 6.55274L23.7363 6.01123ZM29.0059 11.4215L28.6317 11.6579L29.4475 12.6052V11.963L29.0059 11.4215Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9219 5.57227L26.6271 9.83244L27.0013 9.62958L23.9417 6.11377L22.9219 5.57227ZM28.7022 11.6247L28.3279 11.8276L29.449 13.1454V12.5032L28.7022 11.6247Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1055 5.13281L26.3214 10.0016L26.6956 9.79872L23.1253 5.67432L22.1055 5.13281ZM28.3949 11.7938L28.0207 11.9967L29.4501 13.6532V13.011L28.3949 11.7938Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2559 4.69189L26.0147 10.1709L26.3889 9.968L22.3094 5.2334L21.2559 4.69189ZM28.0897 11.9631L27.7155 12.166L29.4501 14.1595V13.5173L28.0897 11.9631Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4395 4.25439L25.7074 10.3723L26.0832 10.1375L21.4593 4.7943L20.4395 4.25439ZM27.7824 12.131L27.4082 12.3339L29.448 14.7012V14.059L27.7824 12.131Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5898 3.81348L25.4038 10.5432L25.7765 10.3052L20.6434 4.35658L19.5898 3.81348ZM27.511 12.3003L27.1031 12.5031L29.448 15.2091V14.5638L27.511 12.3003Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7734 3.37402L25.0966 10.7107L25.5045 10.4743L19.827 3.91553L18.7734 3.37402ZM27.2054 12.4694L26.8295 12.6723L29.4474 15.7488V15.0747L27.2054 12.4694Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.959 2.93506L24.8266 10.8804L25.1992 10.644L18.9788 3.47657L17.959 2.93506ZM26.9 12.6391L26.5258 12.8419L29.4489 16.2571V15.615L26.9 12.6391Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1094 2.46191L24.5198 11.0494L24.894 10.8129L18.163 3.03697L17.1094 2.46191ZM26.5933 12.8081L26.2191 13.0109L29.4489 16.7647V16.121L26.5933 12.8081Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.293 2.02295L24.2142 11.219L24.5868 11.0161L17.3466 2.598L16.293 2.02295ZM26.2876 12.9777L25.9134 13.1806L29.4484 17.305V16.6293L26.2876 12.9777Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4766 1.61719L23.9085 11.3883L24.2811 11.1854L16.4964 2.1571L15.4766 1.61719ZM25.9803 13.1454L25.6061 13.3482L29.4478 17.8113V17.1691L25.9803 13.1454Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9316 1.48125L23.6013 11.5574L23.9739 11.3546L15.6801 1.71766L15.4761 1.61702C15.3114 1.52086 15.1225 1.47373 14.9316 1.48125ZM25.6747 13.3145L25.3005 13.5174L29.4474 18.3191V17.6769L25.6747 13.3145Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9314 1.48145C14.7949 1.48145 14.6583 1.51499 14.5234 1.54853L23.2942 11.7254L23.7022 11.5225L15.0342 1.48145L14.9314 1.48145ZM25.403 13.4841L25.0288 13.6869L29.4471 18.8608V18.1835L25.403 13.4841Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6267 1.51465C14.5576 1.54819 14.4564 1.58174 14.4227 1.61688L14.2188 1.71751L23.0233 11.8943L23.3975 11.6915L14.6267 1.51625V1.51465ZM25.0967 13.653L24.7225 13.8894L29.4476 19.3684V18.7247L25.0967 13.653Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2863 1.65039L13.9121 1.85326L22.7166 12.0636L23.0909 11.8608L14.2863 1.65039ZM24.7901 13.8223L24.4175 14.0587L29.4477 19.8732V19.231L24.7901 13.8223Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.98 1.81982L13.6074 2.02269L22.412 12.2331L22.7862 12.0302L13.98 1.81982ZM24.4838 13.9918L24.1112 14.2282L29.4482 20.4148V19.7726L24.4838 13.9918Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.675 1.98779L13.3008 2.19066L22.1053 12.4026L22.4795 12.1998L13.675 1.98779ZM24.1788 14.1597L23.8061 14.3977L29.4483 20.923V20.2808L24.1788 14.1597Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3687 2.15674L12.9961 2.3596L21.8006 12.5716L22.1748 12.3687L13.3687 2.15674ZM23.8725 14.3287L23.4999 14.5651L29.4488 21.429V20.7868L23.8725 14.3287Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0633 2.32764L12.6875 2.52731L21.492 12.7377L21.8662 12.5348L13.0633 2.32764ZM23.6024 14.4996L23.2282 14.7344L29.4485 21.9705V21.3283L23.6024 14.4996Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7554 2.46191L12.3828 2.69832L21.2211 12.9087L21.5953 12.7058L12.7554 2.46191ZM23.2945 14.7009L22.9203 14.9038L29.4474 22.4769V21.8348L23.2945 14.7009Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4504 2.63135L12.0762 2.83421L20.9144 13.0781L21.2886 12.8753L12.4504 2.63135ZM22.9895 14.8704L22.6153 15.0732L29.4475 23.0185V22.3428L22.9895 14.8704Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1441 2.79932L11.7715 3.00218L20.6097 13.2812L20.984 13.0448L12.1441 2.79932ZM22.6832 15.0399L22.309 15.2428L29.448 23.5267V22.883L22.6832 15.0399Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8391 2.96826L11.4648 3.17113L20.3031 13.4502L20.6773 13.2138L11.8391 2.96826ZM22.3782 15.2089L22.0039 15.4117L29.4481 24.0327V23.3906L22.3782 15.2089Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5328 3.1377L11.1602 3.34056L19.9984 13.6212L20.3726 13.3848L11.5328 3.1377ZM22.0719 15.3783L21.6976 15.5812L29.4486 24.5744V23.8987L22.0719 15.3783Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2261 3.30713L10.8535 3.50999L19.6918 13.789L20.066 13.551L11.2261 3.30713ZM21.8006 15.5462L21.4263 15.749L29.4487 25.0808V24.4387L21.8006 15.5462Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9197 3.44287L10.5117 3.64574L19.419 13.9567L19.7933 13.7203L10.9197 3.44287ZM21.4925 15.7154L21.1183 15.9183L29.4474 25.5888V24.9466L21.4925 15.7154Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.615 3.61035L10.207 3.81322L19.1481 14.1594C19.1747 14.0995 19.2228 14.0517 19.283 14.0252L19.487 13.8894L10.615 3.61035ZM21.1878 15.8845L20.8136 16.0874L29.3804 26.0278C29.4189 25.9308 29.4416 25.8284 29.4479 25.7243V25.4527L21.1878 15.8845Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3099 3.78125L9.90039 3.98252L19.047 14.5651V14.4309C19.047 14.3287 19.1161 14.1945 19.1835 14.0922L10.3099 3.78125ZM20.8812 16.0538L20.6081 16.2231C20.576 16.2231 20.5423 16.2551 20.5069 16.2551L29.2103 26.3664C29.3049 26.2461 29.3742 26.1081 29.4143 25.9607L20.8812 16.0538Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0036 3.94922L9.5957 4.15208L19.0459 15.1068V14.4311L10.0036 3.94922ZM19.9292 16.0876L28.9715 26.6031C29.0742 26.5344 29.177 26.4002 29.2782 26.2996L20.5765 16.2234C20.5015 16.2569 20.4202 16.2743 20.338 16.2743C20.2557 16.2743 20.1745 16.2569 20.0995 16.2234L19.9292 16.0876Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69701 4.11865L9.28906 4.32152L28.668 26.7725L28.9411 26.6367L29.0422 26.5345L20.1365 16.2235H20.1012L19.3206 15.7491C19.2516 15.7171 19.2178 15.6484 19.1504 15.5798C19.0813 15.4791 19.0813 15.412 19.0476 15.3433V14.9712L9.69701 4.11865Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39037 4.2876L8.98242 4.49046L28.3598 26.9399L28.734 26.737L9.39037 4.2876Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08373 4.42188L8.67578 4.62474L28.0885 27.1093L28.4611 26.9064L9.08373 4.42188Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77904 4.59131L8.37109 4.79417L27.7822 27.2787L28.1564 27.0758L8.77904 4.59131Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4724 4.76074L8.06445 4.96361L27.4787 27.4481L27.8514 27.2453L8.4724 4.76074Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13398 4.93018L7.75977 5.13304L27.1708 27.6511L27.5451 27.4147L8.13398 4.93018Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82734 5.09912L7.45312 5.30199L26.8658 27.8201L27.2384 27.5837L7.82734 5.09912Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52265 5.26709L7.14844 5.47155L26.5932 27.9896L26.9675 27.7516L7.52265 5.26709Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21601 5.40283L6.8418 5.6057L26.2882 28.1573L26.6624 27.9209L7.21601 5.40283Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90937 5.57227L6.53516 5.77513L25.98 28.3268L26.3542 28.1239L6.90937 5.57227Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60273 5.74121L6.22852 5.94408L15.6803 16.8988L15.9854 17.1017C16.122 17.1688 16.2585 17.3381 16.2585 17.5074V17.541L25.6749 28.4957L26.0491 28.2928L6.60273 5.74121Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29804 5.91064L5.92383 6.11351L14.7958 16.4261L15.9185 17.0331L6.29804 5.91064ZM16.2236 17.4053C16.2236 17.4404 16.259 17.474 16.259 17.5075V18.0826L25.3686 28.6651L25.7429 28.4623L16.2236 17.4053Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9914 6.08008L5.61719 6.28294L13.9126 15.9183L15.0352 16.5269L5.9914 6.08008ZM16.2591 17.9485V18.5891L25.0973 28.8346L25.4715 28.6317L16.2591 17.9485Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68511 6.24756L5.3125 6.45042L13.0634 15.4116L14.1508 16.0186L5.68511 6.24756ZM16.2595 18.4546V19.1303L24.791 29.002L25.1653 28.8008L16.2595 18.4546Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.38008 6.38525L5.00586 6.58652L12.1802 14.904L13.2675 15.5462L5.38008 6.38525ZM16.2597 18.9949V19.637L24.486 29.1733L24.8602 28.9688L16.2597 18.9949Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07344 6.55273L4.69922 6.7556L11.2938 14.3974L12.3827 15.0395L5.07344 6.55273ZM16.2582 19.5026V20.1447L24.1778 29.3408L24.552 29.1379L16.2582 19.5026Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7684 6.7207L4.39258 6.92517L10.4106 13.9232L11.4979 14.5318L4.7684 6.7207ZM16.2583 20.0108V20.6865L23.8711 29.5439L24.2469 29.3075L16.2583 20.0108Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46211 6.8916L4.08789 7.09447L9.52768 13.4168L10.615 14.0238L4.46211 6.8916ZM16.2588 20.5491V21.1928L23.6018 29.7132L23.9744 29.4768L16.2588 20.5491Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15547 7.05908L3.78125 7.26195L8.64285 12.9086L9.7655 13.5172L4.15547 7.05908ZM16.2589 21.0568V21.7005L23.2951 29.8823L23.6693 29.6458L16.2589 21.0568Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85078 7.22852L3.47656 7.43138L7.75998 12.4024L8.88102 13.0445L3.85078 7.22852ZM12.7565 18.1833L13.6398 19.1976V18.8254C13.6398 18.7583 13.5724 18.6577 13.5049 18.6225L12.7565 18.1833ZM16.2577 21.5649V22.2406L22.9904 30.0517L23.363 29.8153L16.2577 21.5649Z",
    fill: "#DB0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54219 7.36426L3.16797 7.56712L6.8748 11.896L7.99585 12.5365L3.54219 7.36426ZM11.8713 17.6769L13.638 19.7055V19.0634L12.994 18.319L11.8713 17.6769ZM16.2559 22.1064V22.7485L22.6818 30.221L23.0561 30.0181L16.2559 22.1064Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2375 7.53369L2.86328 7.73656L6.02405 11.4217L7.11297 12.0287L3.2375 7.53369ZM10.9884 17.2026L13.6385 20.2455V19.6034L12.1095 17.8111L10.9884 17.2026ZM16.2564 22.6128V23.255L22.3755 30.3888L22.7498 30.1859L16.2564 22.6128Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93086 7.70312L2.55664 7.90599L5.14243 10.9138L6.22814 11.5224L2.93086 7.70312ZM10.1389 16.6963L13.6402 20.7536V20.1115L11.2247 17.3049L10.1389 16.6963ZM16.2581 23.1545V23.7966L22.1042 30.5583L22.4785 30.3554L16.2581 23.1545Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62617 7.87061L2.25195 8.07347L4.25795 10.4072L5.34526 11.0142L2.62617 7.87061ZM9.25446 16.1881L13.6391 21.2597V20.6176L10.345 16.8318L9.25446 16.1881ZM16.257 23.6606V24.3027L21.7979 30.7273L22.1738 30.5245L16.257 23.6606Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31953 8.04004L1.94531 8.2429L3.37472 9.89937L4.46204 10.5431L2.31953 8.04004ZM8.37124 15.6818L13.6392 21.8014V21.1592L9.45855 16.324L8.37124 15.6818ZM16.2571 24.1687V24.8108L21.4929 30.8968L21.8671 30.6939L16.2571 24.1687Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01289 8.20947L1.63867 8.41234L2.48989 9.39312L3.61094 10.0353L2.01289 8.20947ZM7.48641 15.2091L13.6377 22.3094V21.6657L8.57372 15.8177L7.48641 15.2091ZM16.2556 24.7087V25.3524L21.1863 31.0662L21.5605 30.8633L16.2556 24.7087Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70677 8.34521L1.29883 8.54808L1.60398 8.92027L2.72824 9.52727L1.70677 8.34521ZM6.6021 14.7027L13.6399 22.8493V22.1736L7.72315 15.3097L6.6021 14.7027ZM16.2579 25.2166V25.8587L20.8801 31.269L21.2544 31.0326L16.2579 25.2166Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40176 8.51416L1.16406 8.64834L1.84343 9.02053L1.40176 8.51416ZM5.7189 14.1944L13.6401 23.3569V22.7148L6.83995 14.8349L5.7189 14.1944ZM16.258 25.7226V26.3999L20.6089 31.438L20.9831 31.2L16.258 25.7226Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86914 13.6865L13.6383 23.8634V23.2212L5.95646 14.3287L4.86914 13.6865ZM16.2562 26.2642V26.9063L20.3036 31.6058L20.6762 31.3694L16.2562 26.2642Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98438 13.2139L13.6401 24.405V23.7293L5.0733 13.8225L3.98438 13.2139ZM16.258 26.7723V27.4145L19.997 31.7753L20.3712 31.5389L16.258 26.7723Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.10156 12.7061L13.6407 24.9115V24.2694L4.18888 13.3147L3.10156 12.7061ZM16.2586 27.2788V27.9545L19.6892 31.9447L20.0634 31.7419L16.2586 27.2788Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.21875 12.1997L13.6412 25.4195V24.7774L3.30607 12.8418L2.21875 12.1997ZM16.2591 27.8204V28.4625L19.3861 32.1141L19.7604 31.9112L16.2591 27.8204Z",
    fill: "#DB0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33398 11.6914L13.6414 25.9607V25.3169L2.42291 12.3335L1.33398 11.6914ZM16.2593 28.3264V28.9685L19.1149 32.2831L19.4875 32.0802L16.2593 28.3264Z",
    fill: "#DA0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.448872 11.2188L13.6396 26.4672V25.8251L1.57152 11.8273L0.447266 11.2188H0.448872ZM16.2575 28.8345V29.5102L18.8064 32.4525L19.1806 32.2497L16.2575 28.8345Z",
    fill: "#D90032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 11.1851V11.6579L13.6405 26.975V26.3313L0.687443 11.3208L0.416016 11.1851ZM16.2584 29.3743V29.78C16.2568 29.8429 16.2323 29.9031 16.1893 29.9493L18.5021 32.6201L18.8747 32.4173L16.2568 29.3743H16.2584Z",
    fill: "#D80032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 11.5225V12.1997L13.6405 27.5153V26.8732L0.416016 11.5225ZM16.2231 29.8826C16.1909 30.0184 16.0881 30.1541 15.9854 30.1861L15.9532 30.2212L18.1953 32.7898L18.5695 32.5869L16.2247 29.8826H16.2231Z",
    fill: "#D70032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 12.064V12.7061L13.6405 28.0233V27.3811L0.416016 12.064ZM16.0191 30.1541C16.0191 30.1877 16.0191 30.1877 15.987 30.1877L15.6465 30.3906L17.8902 32.9607L18.2628 32.7579L16.0191 30.1541Z",
    fill: "#D60032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 12.5718V13.2139L13.6405 28.5295V27.8873L0.416016 12.5718ZM15.7477 30.3217L15.3397 30.5581L17.6171 33.1618L17.9913 32.9254L15.7477 30.3217Z",
    fill: "#D50032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 13.1118V13.754L13.6405 29.0711V28.429L0.416016 13.1118ZM15.4425 30.4912L15.2032 30.6269C15.1357 30.6589 15.0683 30.6589 14.9992 30.6589L17.312 33.3313L17.6862 33.0949L15.4425 30.4912Z",
    fill: "#D40032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 13.6196V14.2602L13.6405 29.5757V28.9336L0.416016 13.6196ZM14.3889 30.4894L17.0068 33.4989L17.3794 33.2624L15.102 30.6587C15.0683 30.6587 14.9992 30.6907 14.9655 30.6907H14.9334C14.8306 30.6907 14.7615 30.6587 14.6925 30.6252L14.3873 30.4894H14.3889Z",
    fill: "#D30032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 14.126V14.8033L16.7001 33.6682L17.0743 33.4317L14.6266 30.5916L13.8782 30.1859C13.8062 30.145 13.7464 30.0859 13.7047 30.0147C13.663 29.9435 13.6408 29.8626 13.6405 29.7802V29.4431L0.416016 14.126Z",
    fill: "#D20032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 14.6675V15.3096L16.3933 33.8391L16.7675 33.6346L0.416016 14.6675Z",
    fill: "#D10032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 15.1738V15.8176L16.0881 34.0068L16.4624 33.8039L0.416016 15.1738Z",
    fill: "#D00032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 15.6816V16.3573L15.8151 34.176L16.1893 33.9731L0.416016 15.6816Z",
    fill: "#CF0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 16.2231V16.8653L15.51 34.3453L15.8842 34.1424L0.416016 16.2231Z",
    fill: "#CE0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 16.7295V17.3716L15.1695 34.4794C15.2723 34.4475 15.3734 34.4123 15.4746 34.3788L15.5774 34.3117L0.416016 16.7295Z",
    fill: "#CD0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 17.2378V17.9135L14.7278 34.4814H14.9318C15.0346 34.4814 15.1357 34.4814 15.2369 34.4462L0.416016 17.2378Z",
    fill: "#CC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 17.7773V18.4195L13.9456 34.1088L14.4226 34.3788C14.5238 34.4459 14.6941 34.481 14.8306 34.481L0.416016 17.7773Z",
    fill: "#CB0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 18.2856V18.9278L13.0623 33.6012L14.1833 34.2433L0.416016 18.2856Z",
    fill: "#CA0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 18.8257V19.4694L12.1789 33.095L13.3 33.7371L0.416016 18.8257Z",
    fill: "#C90032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 19.3335V19.9756L11.294 32.5868L12.3829 33.229L0.416016 19.3335Z",
    fill: "#C80033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 19.8398V20.4836L10.4106 32.0805L11.498 32.7226L0.416016 19.8398Z",
    fill: "#C70033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 20.3813V21.0235L9.49197 31.539L10.6146 32.1811L0.416016 20.3813Z",
    fill: "#C60033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 20.8892V21.5313L8.60863 31.0324L9.73128 31.6746L0.416016 20.8892Z",
    fill: "#C50033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 21.3955V22.0376L7.72368 30.5245L8.84793 31.1666L0.416016 21.3955Z",
    fill: "#C40033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 21.937V22.5792L6.84033 30.0181L7.96298 30.6602L0.416016 21.937Z",
    fill: "#C30033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 22.4434V23.0855L5.95699 29.5101L7.07964 30.1522L0.416016 22.4434Z",
    fill: "#C20033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 22.9497V23.627L5.07365 29.0037L6.16096 29.6459L0.416016 22.9497Z",
    fill: "#C10033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 23.4932V24.1353L4.15497 28.4961L5.27762 29.1383L0.416016 23.4932Z",
    fill: "#C00033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 23.9995V24.6417L3.27163 27.9897L4.39267 28.5967L0.416016 23.9995Z",
    fill: "#BF0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 24.5059V25.1831L2.38828 27.4482L3.50933 28.0903L0.416016 24.5059Z",
    fill: "#BE0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 25.0474V25.6895L1.50333 26.9402L2.62598 27.584L0.416016 25.0474Z",
    fill: "#BD0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.416016 25.5537V25.723C0.416016 26.0617 0.653715 26.4674 0.925143 26.6367L1.74103 27.076L0.416016 25.5553V25.5537Z",
    fill: "#BC0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.619141 26.3315C0.686596 26.4002 0.720324 26.4673 0.789385 26.5009L0.619141 26.3315Z",
    fill: "#BB0033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3295_41006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 33,
    fill: "white",
    transform: "translate(0.298828 0.209473)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpdLogo);
export default __webpack_public_path__ + "static/media/dpd_logo.480b2b332127216a2d707b2888606ca0.svg";
export { ForwardRef as ReactComponent };